import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight: '300px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.nearWhite
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '8px'
    }
  },

  inbox: {
    marginLeft: '-16px !important'
  }
}))

export default useStyles
